// extracted by mini-css-extract-plugin
export var base = "OverlayMenu-module--base--3897d";
export var closeButton = "OverlayMenu-module--close-button--12449";
export var hide = "OverlayMenu-module--hide--8ac3f";
export var menu = "OverlayMenu-module--menu--beba5";
export var show = "OverlayMenu-module--show--2daa1";